module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-swap-25060607e10644ff1001d509927054f3.png";